export default {
  uploadQueueContains: (state) => (ref) => {
    if (state.uploadQueue.length === 0) {
      return false;
    }
    return state.uploadQueue.find((q) => (`${q.destinationPath}/${q.destinationFilename}`).startsWith(ref));
  },
};
